// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/coil-spring/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const coilSpringEN: PageEntry = {
  id: "post.schraubenfeder",
  locale: "en",
  slug: "coil-spring",
  seo: {
    title: "Glossary: Coil spring explained simply | Dietz GmbH",
    description: "Helical springs are spirally wound metal springs that allow elastic deformation due to their shape and structure. These springs are often used in mechanical systems to absorb, stor",
  },
  type: "post",
  h1: "Glossary: Coil spring explained simply",
  intro: "Helical springs are spirally wound metal springs that allow elastic deformation due to their shape and structure. These springs are often used in mechanical systems to absorb, store or transmit forces. The design of a coil spring enables it to store energy under load and release it again when required. This makes them particularly suitable for applications such as shock absorbers in vehicles, springs in locking mechanisms or for pre-tensioning components. The selection of the right coil spring depends on parameters such as spring constant, choice of material and spring geometry.",
  blocks: [

  ],
};
